// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"8f0247fa","497":"f6c48f16"}[chunkId] + ".chunk.css";
};